import {
  DeploymentEnvironment,
  getRuntimeConfig,
  initSentry,
} from '@hclinear/hc-linear-react';

export const initializeSentry = () => {
  const deploymentEnvironment = getRuntimeConfig().DEPLOYMENT_ENVIRONMENT;

  const enabled = deploymentEnvironment !== DeploymentEnvironment.LOCAL;
  const release = `${deploymentEnvironment}-${__APP_VERSION__}`;
  const dsn = getRuntimeConfig().SENTRY_DSN;
  initSentry({ release, dsn }, enabled);
};
